export const BASE_FONT_SIZE = 16
export const SPACING_MULTIPLIER = 4
export enum Mode {
  LIGHT = 'light',
  DARK = 'dark',
}
